import {
    CLICKED_MEDICARE_BANNER_CHOICE_KEY,
    type DrugPathwayOptions,
    type PathwayAlertConfig,
    type PathwayOptionConfig,
    type ProgramTerms,
} from '../../shared';
import {
    INSURANCE_SELECTIONS_HEADING,
    NO_PRIOR_AUTH_BULLET,
    READY_FAST_BULLET,
} from '../../shared-content';
import {
    REVIEW_DETAILS_DESCRIPTION,
    ZEPBOUND_JOURNEY_TERMS_URL,
    ZEPBOUND_MEDICARE_BRIDGE_CARD_BASE,
    ZEPBOUND_TERMS_URL,
} from '../shared';

export const zepboundVialTerms: ProgramTerms = {
    'self-pay': {
        heading: 'LillyDirect® Zepbound® Single-Dose Vial Self-Pay',
        body: '',
        termsUrl: ZEPBOUND_TERMS_URL,
        incentiveProgram: {
            name: 'Zepbound® Self-Pay Journey Program',
            disclaimer:
                'You will be asked to certify conditions of purchase, including that you have been prescribed the Zepbound® Single-Dose Vial for an approved use consistent with FDA-approved product labeling.',
            terms: '',
            termsUrl: ZEPBOUND_JOURNEY_TERMS_URL,
        },
    },
};

export const zepboundVialPathwayAlerts: PathwayAlertConfig[] = [
    {
        pathways: ['self-pay', 'fallback'],
        screens: ['pharmacy-preview', 'pharmacy-select'],
        color: 'info',
        content:
            '<b>Eligible Medicare Part D patients may have coverage through the Medicare GLP\u20111 Bridge.</b>',
        cta: {
            text: 'I have Medicare Part D',
            patientChoiceKey: CLICKED_MEDICARE_BANNER_CHOICE_KEY,
            target: {
                pathway: 'government',
                subPathway: 'medicare-bridge',
            },
        },
    },
];

// Vial bridge card adds a linked priceNote (CMS URL) on top of the shared base.
const medicareBridgeCard: PathwayOptionConfig = {
    ...ZEPBOUND_MEDICARE_BRIDGE_CARD_BASE,
    content: {
        ...ZEPBOUND_MEDICARE_BRIDGE_CARD_BASE.content,
        priceNote:
            '<caption>*Eligibility based on <a href="https://www.cms.gov/medicare/coverage/prescription-drug-coverage/medicare-glp-1-bridge">Medicare GLP\u20111 Bridge Clinical Criteria</a>. Certain plan types excluded. Not a guarantee of coverage.</caption>',
        fallbackTermsUrl: ZEPBOUND_TERMS_URL,
        fallbackDisclaimer:
            'Additional taxes and fees may apply. You will be asked to certify conditions of purchase, including that you have been prescribed the Zepbound® Single-Dose Vial for an approved use consistent with FDA-approved product labeling.',
    },
};

// Vial self-pay card has a unique first bullet — stays on Vial, no switch context.
const selfPayCard: PathwayOptionConfig = {
    id: 'self-pay',
    fillPathway: 'self-pay',
    headlinePriceType: 'CashAssistance',
    content: {
        heading: 'Self-Pay',
        headerIcon: 'account-balance-wallet',
        subHeading: 'Exclusively available through LillyDirect',
        showPrice: true,
        priceSuperscript: '‡',
        bullets: [
            {
                key: 'noInsurance',
                icon: 'check',
                color: 'success',
                text: 'No insurance needed to get started — you can check your Medicare coverage anytime',
            },
            NO_PRIOR_AUTH_BULLET,
            READY_FAST_BULLET,
        ],
        disclaimer:
            'Additional taxes and fees may apply. You will be asked to certify conditions of purchase, including that you have been prescribed the Zepbound® Single-Dose Vial for an approved use consistent with FDA-approved product labeling.',
        button: 'Use self-pay',
    },
};

export const zepboundVialPathwayOptions: DrugPathwayOptions = {
    default: { cards: [selfPayCard] },
    medicareBridge: {
        heading: INSURANCE_SELECTIONS_HEADING,
        description: REVIEW_DETAILS_DESCRIPTION,
        cards: [medicareBridgeCard, selfPayCard],
    },
};
